import {Component, OnInit} from "@angular/core";
import {New} from "./new";
import {NewService} from "./new.service";
import {Router} from "@angular/router";
declare var jquery:any; // 這邊用 var 
declare let $:any; // 當然 let 也可以
@Component({
  template:`    
    <div class="big-about">
       
        <div class="middle-box"><br>
        <h2>最新消息</h2><br>
        <div class="line-about"></div><br>
        <p>關於本店近況及商品的最新消息皆會在此不定期發佈！！！
        </p>
        </div></div>
        <div class="container">
        <div class="title-clothes">
        <div class="title-clothes-line"></div>最新消息<div class="title-clothes-line2"></div>
        </div>

        <div class="categoryBtn">
        <button class="newBtn2" (click)="gotoNew()">全部</button>

        <button class="newBtn2" (click)="gotoNew2()">活動</button>
        <button class="newBtn2" (click)="gotoNew3()">評測</button>
        <button class="newBtn2" (click)="gotoNew4()">新品</button>
        <button class="newBtn2" (click)="gotoNew5()">重要</button>
        <button class="newBtn2" (click)="gotoNew6()">情報</button>
        </div>
        <div class="cool"><button class="changefont" (click)="gotoDetail203()">2020-04-13<span class="category">活動</span><p class="cool2"></p>【波爾桌球】四月優惠活動開跑</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail199()">2020-03-08<span class="category">活動</span><p class="cool2"></p>"BUTTERFLY"2020年『旗艦產品限量預購活動』</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail189()">2019-12-16<span class="category">活動</span><p class="cool2"></p>『STIGA 首款德製DNA膠皮講習會』開放報名～</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail186()">2019-12-09<span class="category">活動</span><p class="cool2"></p>2020年波爾桌球桌曆-- 風一樣的女子『劉昱昕』</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail180()">2019-10-26<span class="category">活動</span><p class="cool2"></p>"BUTTERFLY"林高遠ALC、D64、D80 預約試打</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail172()">2019-08-23<span class="category">活動</span><p class="cool2"></p>開學季門市鞋類商品特價 📣 萬隆體驗站限定 📣</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail171()">2019-08-05<span class="category">活動</span><p class="cool2"></p>波爾桌球萬隆體驗站限時優惠 👉 至8月31前</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail165()">2019-06-22<span class="category">活動</span><p class="cool2"></p>2019『怡靜』與台灣桌球粉絲的美麗見面會</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail164()">2019-06-15<span class="category">活動</span><p class="cool2"></p>2019台灣一姐鄭怡靜-6月22日台北見面會在"波爾"</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail154()">2019-05-04<span class="category">活動</span><p class="cool2"></p>台灣一姊鄭怡靜(世界排名No.8)球迷簽名見面會</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail147()">2019-04-11<span class="category">活動</span><p class="cool2"></p>"波爾萬隆體驗站" 好禮大放送 周年慶抽不完</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail143()">2019-03-21<span class="category">活動</span><p class="cool2"></p>波爾桌球萬隆店一週年抽獎活動</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail123()">2019-01-07<span class="category">活動</span><p class="cool2"></p>我和🏓桌球女神「鄭先知」有個約會2019🎉👍🙏</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail119()">2018-12-20<span class="category">活動</span><p class="cool2"></p>桌球女神『鄭先知』簽名握手會🏃🏻🏃🏻🏃🏻</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail117()">2018-12-14<span class="category">活動</span><p class="cool2"></p>2018 Christmas Sales 感恩回饋活動🎁🎄⛄❄️</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail116()">2018-12-09<span class="category">活動</span><p class="cool2"></p>桌球明星『鄭先知』簽名握手會 COMING SOON...</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail100()">2018-10-15<span class="category">活動</span><p class="cool2"></p>【波爾桌球×美津濃桌球教室】成功圓滿結束</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail95()">2018-09-13<span class="category">活動</span><p class="cool2"></p>9月開學感謝大特賣(9/14~9/30 限萬隆)</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail94()">2018-09-12<span class="category">活動</span><p class="cool2"></p>【波爾桌球×美津濃桌球教室】熱烈報名中！</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail93()">2018-09-11<span class="category">活動</span><p class="cool2"></p>波爾桌球"年中會員禮"活動開跑來囉！！</button><br><br></div> 

        <button class="newBtn" (click)="show1()" *ngIf="more1 == false">更多消息</button>

        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail89()">2018-09-06<span class="category">活動</span><p class="cool2"></p>"STIGA" AIROC astro/MANTRA 價格調整</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail86()">2018-08-27<span class="category">活動</span><p class="cool2"></p>賀亞運棒球終於贏了南韓隊，STIGA球拍買一送一</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail85()">2018-08-21<span class="category">活動</span><p class="cool2"></p>今年暑假最後一檔 - 加價購/滿額贈 🔥🔥🔥</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail80()">2018-08-01<span class="category">活動</span><p class="cool2"></p>BUTTERFLY ROZENA 膠皮(破盤大特價！)</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail59()">2018-04-29<span class="category">活動</span><p class="cool2"></p>"MIZUNO美津濃"桌球膠皮Q3+專業底板試打會</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail50()">2018-04-11<span class="category">活動</span><p class="cool2"></p>"波爾桌球-萬隆體驗站"感恩回饋第二波</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail40()">2018-03-08<span class="category">活動</span><p class="cool2"></p>日本"BUTTERFLY"桌球鞋 5折特賣活動開跑囉！</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail33()">2017-12-29<span class="category">活動</span><p class="cool2"></p>2017感恩大回饋"年終會員禮"來囉～</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail14()">2017-10-15<span class="category">活動</span><p class="cool2"></p>獨 ❗️家 ❗️商 ❗️品 ❗️限時預購～</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail1()">2017-07-06<span class="category">活動</span><p class="cool2"></p>FB現場直播 * 送球拍 * 活動預告</button><br><br></div> 
        <button (click)="topFunction()" id="return-to-top" title="Go to top">Top</button>
    
       </div>
      
    `,
  providers:[NewService],
  styles: [`    
    .cool button{
    float: left;
    background-color: white;
    margin-left: 30px;
    border: none;
    
    }
    
    .cool{
    width:700px;
    font-size: 18px;
    font-weight: bold;
    }
    
   
    .container{
    margin-bottom: 30px;
    }
    
    `],
  inputs:['ptitle','pcontent']

})

export class New2Component implements OnInit{
  constructor(private newservice:NewService,private router:Router){}
  new:New[];
  errorMessage:string;
  public ptitle:string;
  public pcontent:string;
  public more1 : boolean = false 

  ngOnInit(){
    this.getNews();
  }

  select2(title:string,content:string){
    this.newservice.add(title,content);
  }

  getNews(){
    this.newservice.getNews()
      .subscribe(
        products => this.new = products,
        error =>  this.errorMessage = <any>error);


  }
  gotoNew(){
    this.router.navigate(['new']);
  }
  gotoNew2(){
    this.router.navigate(['new2']);
  }
  gotoNew3(){
    this.router.navigate(['new3']);
  }
  gotoNew4(){
    this.router.navigate(['new4']);
  }
  gotoNew5(){
    this.router.navigate(['new5']);
  }
  gotoNew6(){
    this.router.navigate(['new6']);
  }
  gotoNew7(){
    this.router.navigate(['new7']);
  }
  gotoNew8(){
    this.router.navigate(['new8']);
  }
  show1(){
    this.more1 = true
  }

  gotoNewDetail(){
    this.router.navigate(['newdetail']);
  }
  gotoDetail1(){
    this.router.navigate(['detail1']);
  }
  gotoDetail2(){
    this.router.navigate(['detail2']);
  }
  gotoDetail3(){
    this.router.navigate(['detail3']);
  }
  gotoDetail4(){
    this.router.navigate(['detail4']);
  }
  gotoDetail5(){
    this.router.navigate(['detail5']);
  }
  gotoDetail6(){
    this.router.navigate(['detail6']);
  }
  gotoDetail7(){
    this.router.navigate(['detail7']);
  }
  gotoDetail8(){
    this.router.navigate(['detail8']);
  }
  gotoDetail9(){
    this.router.navigate(['detail9']);
  }
  gotoDetail10(){
    this.router.navigate(['detail10']);
  }
  gotoDetail11(){
    this.router.navigate(['detail11']);
  }
  gotoDetail12(){
    this.router.navigate(['detail12']);
  }
  gotoDetail13(){
    this.router.navigate(['detail13']);
  }
  gotoDetail14(){
    this.router.navigate(['detail14']);
  }
  gotoDetail15(){
    this.router.navigate(['detail15']);
  }
  gotoDetail16(){
    this.router.navigate(['detail16']);
  }
  gotoDetail17(){
    this.router.navigate(['detail17']);
  }
  gotoDetail18(){
    this.router.navigate(['detail18']);
  }
  gotoDetail19(){
    this.router.navigate(['detail19']);
  }
  gotoDetail20(){
    this.router.navigate(['detail20']);
  }
  gotoDetail21(){
    this.router.navigate(['detail21']);
  }
  gotoDetail22(){
    this.router.navigate(['detail22']);
  }
  gotoDetail23(){
    this.router.navigate(['detail23']);
  }
  gotoDetail24(){
    this.router.navigate(['detail24']);
  }
  gotoDetail25(){
    this.router.navigate(['detail25']);
  }
  gotoDetail26(){
    this.router.navigate(['detail26']);
  }
  gotoDetail27(){
    this.router.navigate(['detail27']);
  }
  gotoDetail28(){
    this.router.navigate(['detail28']);
  }
  gotoDetail29(){
    this.router.navigate(['detail29']);
  }
  gotoDetail30(){
    this.router.navigate(['detail30']);
  }
  gotoDetail31(){
    this.router.navigate(['detail31']);
  }
  gotoDetail32(){
    this.router.navigate(['detail32']);
  }
  gotoDetail33(){
    this.router.navigate(['detail33']);
  }
  gotoDetail34(){
    this.router.navigate(['detail34']);
  }
  gotoDetail35(){
    this.router.navigate(['detail35']);
  }
  gotoDetail36(){
    this.router.navigate(['detail36']);
  }
  gotoDetail37(){
    this.router.navigate(['detail37']);
  }
  gotoDetail38(){
    this.router.navigate(['detail38']);
  }
  gotoDetail39(){
    this.router.navigate(['detail39']);
  }
  gotoDetail40(){
    this.router.navigate(['detail40']);
  }
  gotoDetail41(){
    this.router.navigate(['detail41']);
  }
  gotoDetail42(){
    this.router.navigate(['detail42']);
  }
  gotoDetail43(){
    this.router.navigate(['detail43']);
  }
  gotoDetail44(){
    this.router.navigate(['detail44']);
  }
  gotoDetail45(){
    this.router.navigate(['detail45']);
  }
  gotoDetail46(){
    this.router.navigate(['detail46']);
  }
  gotoDetail47(){
    this.router.navigate(['detail47']);
  }
  gotoDetail48(){
    this.router.navigate(['detail48']);
  }
  gotoDetail49(){
    this.router.navigate(['detail49']);
  }
  gotoDetail50(){
    this.router.navigate(['detail50']);
  }
  gotoDetail51(){
    this.router.navigate(['detail51']);
  }
  gotoDetail52(){
    this.router.navigate(['detail52']);
  }
  gotoDetail53(){
    this.router.navigate(['detail53']);
  }
  gotoDetail54(){
    this.router.navigate(['detail54']);
  }
  gotoDetail55(){
    this.router.navigate(['detail55']);
  }
  gotoDetail56(){
    this.router.navigate(['detail56']);
  }
  gotoDetail57(){
    this.router.navigate(['detail57']);
  }
  gotoDetail58(){
    this.router.navigate(['detail58']);
  }
  gotoDetail59(){
    this.router.navigate(['detail59']);
  }
  gotoDetail60(){
    this.router.navigate(['detail60']);
  }
  gotoDetail61(){
    this.router.navigate(['detail61']);
  }
  gotoDetail62(){
    this.router.navigate(['detail62']);
  }
  gotoDetail63(){
    this.router.navigate(['detail63']);
  }
  gotoDetail64(){
    this.router.navigate(['detail64']);
  }
  gotoDetail65(){
    this.router.navigate(['detail65']);
  }
  gotoDetail66(){
    this.router.navigate(['detail66']);
  }
  gotoDetail67(){
    this.router.navigate(['detail67']);
  }
  gotoDetail68(){
    this.router.navigate(['detail68']);
  }
  gotoDetail69(){
    this.router.navigate(['detail69']);
  }
  gotoDetail70(){
    this.router.navigate(['detail70']);
  }
  gotoDetail71(){
    this.router.navigate(['detail71']);
  }
  gotoDetail72(){
    this.router.navigate(['detail72']);
  }
  gotoDetail73(){
    this.router.navigate(['detail73']);
  }
  gotoDetail74(){
    this.router.navigate(['detail74']);
  }
  gotoDetail75(){
    this.router.navigate(['detail75']);
  }
  gotoDetail76(){
    this.router.navigate(['detail76']);
  }
  gotoDetail77(){
    this.router.navigate(['detail77']);
  }
  gotoDetail78(){
    this.router.navigate(['detail78']);
  }
  gotoDetail79(){
    this.router.navigate(['detail79']);
  }
  gotoDetail80(){
    this.router.navigate(['detail80']);
  }
  gotoDetail85(){
    this.router.navigate(['detail85']);
  }
  gotoDetail86(){
    this.router.navigate(['detail86']);
  }
  gotoDetail89(){
    this.router.navigate(['detail89']);
  }
  gotoDetail93(){
    this.router.navigate(['detail93']);
  }
  gotoDetail94(){
    this.router.navigate(['detail94']);
  }
  gotoDetail95(){
    this.router.navigate(['detail95']);
  }
  gotoDetail100(){
    this.router.navigate(['detail100']);
  }
  gotoDetail116(){
    this.router.navigate(['detail116']);
  }
  gotoDetail117(){
    this.router.navigate(['detail117']);
  }
  gotoDetail119(){
    this.router.navigate(['detail119']);
  }
  gotoDetail123(){
    this.router.navigate(['detail123']);
  }
  gotoDetail143(){
    this.router.navigate(['detail143']);
  }
  gotoDetail147(){
    this.router.navigate(['detail147']);
  }
  gotoDetail154(){
    this.router.navigate(['detail154']);
  }
  gotoDetail164(){
    this.router.navigate(['detail164']);
  }
  gotoDetail165(){
    this.router.navigate(['detail165']);
  }
  gotoDetail171(){
    this.router.navigate(['detail171']);
  }
  gotoDetail172(){
    this.router.navigate(['detail172']);
  }
  gotoDetail180(){
    this.router.navigate(['detail180']);
  }
  gotoDetail186(){
    this.router.navigate(['detail186']);
  }
  gotoDetail189(){
    this.router.navigate(['detail189']);
  }
  gotoDetail199(){
    this.router.navigate(['detail199']);
  }
  gotoDetail203(){
    this.router.navigate(['detail203']);
  }
  topFunction() {
    $('body,html').animate({
      scrollTop : 0                       // Scroll to top of body
  }, 500);
}

}



// WEBPACK FOOTER //
// ./src/app/news/new2.component.ts